import React, {useContext} from 'react'
import createStickySider from 'views/AppLocals/factory/createStickySider'
import {AppEntities} from '../../enums'
import createStatusBar from '../../factory/createStatusBar'
import OrganizationOpeningCourses from '../holders/OrganizationOpeningCourses'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {OrganizationChannelSider} from "../holders/OrganizationChannelList";
import OrganizationGroups from "../holders/OrganizationGroups";
import {
    OrganizationChurchOrAnnouncement,
    OrganizationIntroduction,
    OrganizationUpcomingTimetableBlock
} from "../holders/OrganizationInfo";
import {
    OrganizationContactSider,
    OrganizationLinkedPageBlock,
    OrganizationShopsBlock
} from "../holders/OrganizationContactInfo";
import {OrganizationUpcomingEventBlock} from "../holders/OrganizationEventList";
import {OrganizationJoinBlock} from "../holders/OrganizationJoinBlock";
import {OrganizationExaminations} from "../holders/OrganizationExaminations";
import useTranslate from "../../../../modules/local/useTranslate";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

const OrganizationStatusBar = createStatusBar(
    AppEntities.ORGANIZATION,
    OrganizationContainerContext
)

const OrganizationSticker = () => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization} = useContext(OrganizationContainerContext)

    return (
        <div className="flex flex-col gap-4 md:gap-6">
            <OrganizationJoinBlock/>
            {
                (!!isLg && organization?.description) && (
                    <OrganizationIntroduction/>
                )
            }
            {
                !!isLg && <OrganizationChurchOrAnnouncement/>
            }
            {
                (!!isLg && !!organization?.id) && <OrganizationUpcomingTimetableBlock/>
            }
            {
                !!isLg && <OrganizationUpcomingEventBlock/>
            }
            {
                !!isLg && <OrganizationGroups/>
            }
            {
                !!isLg && <OrganizationOpeningCourses/>
            }
            {
                !!isLg && <OrganizationExaminations/>
            }
            {
                !!isLg && <OrganizationChannelSider/>
            }
            {
                !!isLg && <OrganizationContactSider/>
            }
            {
                !!isLg && <OrganizationLinkedPageBlock/>
            }
            {
                !!isLg && <OrganizationShopsBlock/>
            }
            <div className="h-1"/>
        </div>
    )
}

const OrganizationSider = ({Wrapper = 'div', stickySider = true}) =>
    createStickySider({
        Wrapper,
        stickySider,
    })(OrganizationSticker)

export default OrganizationSider
